export default __webpack_public_path__ + "9415809887df999ea70171188885904f.gif";